import { createContext, useState, useContext } from 'react';

const OnTheMoveContext = createContext({});

export const OnTheMoveProvider = ({ children, initialState = {} }) => {
    const [contextData, setContextData] = useState(initialState);

    return (
        <OnTheMoveContext.Provider value={{ contextData, setContextData }}>
            {children}
        </OnTheMoveContext.Provider>
    );
};

export const useOnTheMoveContext = () => {
    return useContext(OnTheMoveContext);
};

export default OnTheMoveContext;